import { Phone, FileText } from "lucide-react";
import { PHONE_DISPLAY, PHONE_LINK } from "@/lib/constants";

export default function StickyMobileCTA() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur-xl border-t border-slate-200 px-3 py-2.5 flex gap-2 shadow-[0_-8px_24px_rgba(2,6,23,0.08)]"
      data-testid="sticky-mobile-cta"
    >
      <a
        href={`tel:${PHONE_LINK}`}
        className="flex-[1.4] inline-flex flex-col items-center justify-center gap-0 bg-slate-950 text-white font-bold py-2.5 px-3 rounded-xl active:bg-blue-600 transition-colors"
        data-testid="sticky-call-button"
      >
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-white/70 font-bold">
          <Phone className="h-3 w-3" />
          Appeler
        </div>
        <div className="font-display text-base font-extrabold tracking-tight leading-tight">{PHONE_DISPLAY}</div>
      </a>
      <a
        href="#devis"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-bold py-3 px-3 rounded-xl active:bg-blue-700 transition-colors text-sm shadow"
        data-testid="sticky-quote-button"
      >
        <FileText className="h-4 w-4" />
        Devis
      </a>
    </div>
  );
}
